import { render, staticRenderFns } from "./ErrorStack.vue?vue&type=template&id=79617f9b&"
import script from "./ErrorStack.vue?vue&type=script&lang=js&"
export * from "./ErrorStack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports